import { styled } from '@mui/material'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import ReloadButton from '../../../containers/BulkSheetView/components/header/ReloadButton'
import SaveButtonArea from '../../../containers/BulkSheetView/components/header/SaveButtonArea'
import { Button } from '../../../components/buttons'
import { intl } from '../../../../i18n'

type Props = {
  loading: boolean
  onReload: () => void
  onAddRow: () => void
  onSave: () => void
}

const Header = ({ loading, onReload, onAddRow, onSave }: Props) => {
  return (
    <HeaderContainer>
      <SaveButtonArea loading={loading} onSubmit={onSave} />
      <ReloadButton onReload={onReload} />
      <Button
        variant="filled"
        colorPattern="skyBlue"
        size="s"
        onClick={onAddRow}
        style={{ marginLeft: '10px' }}
      >
        <AddRoundedIcon fontSize="small" />
        {intl.formatMessage({
          id: 'roles.header.addButton',
        })}
      </Button>
    </HeaderContainer>
  )
}

const HeaderContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  margin: '10px 10px 5px 10px',
  overflowX: 'auto',
  overflowY: 'hidden',
  minHeight: '47px',
})

export default Header
